// extracted by mini-css-extract-plugin
export default {"questions":"question_collapse__questions--2g4X","answer":"question_collapse__answer--iROs"};